import React, { useContext, useReducer } from "react";
import axios from "axios";
import LogsContext from "./LogsContext";
import LogsReducer from "./LogsReducer";
import { GET_LOGS, LOGS_ERROR } from "../types";
import diff from "deep-diff";

import LayoutContext from "../layout/LayoutContext";

const LogsState = (props) => {
  const initialState = {
    logs: null,
    logs_error: null,
  };

  const [state, dispatch] = useReducer(LogsReducer, initialState);

  const { setLoading, setAlert } = useContext(LayoutContext);

  const getLogs = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/logs/");
      for (let x in res.data) {
        let differences = "";
        if (
          (res.data[x].before_image || res.data[x].before_image === "") &&
          (res.data[x].after_image || res.data[x].after_image === "")
        ) {
          differences = diff(res.data[x].before_image, res.data[x].after_image);
        }
        res.data[x] = { ...res.data[x], differences: differences };
      }
      setLoading(false);
      dispatch({
        type: GET_LOGS,
        payload: res.data,
      });
    } catch (err) {
      setLoading(false);
      dispatch({
        type: LOGS_ERROR,
        payload: err.response,
      });
    }
  };

  return (
    <LogsContext.Provider
      value={{
        logs: state.logs,
        logs_error: state.logs_error,
        getLogs,
      }}
    >
      {props.children}{" "}
    </LogsContext.Provider>
  );
};

export default LogsState;
